import { render } from "./PerPeriodScore.vue?vue&type=template&id=7d1bec8a&scoped=true"
import script from "./PerPeriodScore.vue?vue&type=script&lang=js"
export * from "./PerPeriodScore.vue?vue&type=script&lang=js"

import "./PerPeriodScore.vue?vue&type=style&index=0&id=7d1bec8a&scoped=true&lang=css"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0cc0aef14303b400c-1/assemble-sports/singaporerugby-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1bec8a"]])

export default __exports__